console.log('CES Benefits Slider loaded');

function initCesBenefitsSlider(section) {
  const track = section.querySelector('.ces-benefits__cards');
  const nextBtn = section.querySelector('.ces-slider-btn--next');
  const prevBtn = section.querySelector('.ces-slider-btn--prev');

  if (!track || !nextBtn || !prevBtn) return;

  let cards = Array.from(track.children);
  const gap = 24;
  const cardWidth = cards[0].offsetWidth + gap;
  const total = cards.length;

  // 🔁 CLONAR TARJETAS (inicio y final)
  cards.forEach(card => {
    const cloneEnd = card.cloneNode(true);
    cloneEnd.classList.add('clone');
    track.appendChild(cloneEnd);

    const cloneStart = card.cloneNode(true);
    cloneStart.classList.add('clone');
    track.insertBefore(cloneStart, track.firstChild);
  });

  // actualizar lista
  cards = Array.from(track.children);

  let index = total; // empezamos en el primer REAL

  // posicion inicial
  track.scrollLeft = cardWidth * index;

  function moveTo(i, smooth = true) {
    track.style.scrollBehavior = smooth ? 'smooth' : 'auto';
    track.scrollLeft = cardWidth * i;
  }

  nextBtn.addEventListener('click', () => {
    index++;
    moveTo(index);

    if (index === total * 2) {
      setTimeout(() => {
        index = total;
        moveTo(index, false);
      }, 350);
    }
  });

  prevBtn.addEventListener('click', () => {
    index--;
    moveTo(index);

    if (index === total - 1) {
      setTimeout(() => {
        index = total * 2 - 1;
        moveTo(index, false);
      }, 350);
    }
  });
}

/* FRONTEND */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.ces-benefits').forEach(initCesBenefitsSlider);
});

/* SHOPIFY EDITOR */
document.addEventListener('shopify:section:load', (e) => {
  const section = e.target.querySelector('.ces-benefits');
  if (section) initCesBenefitsSlider(section);
});
